import { render, staticRenderFns } from "./TeamMatchCard.vue?vue&type=template&id=6f6d654a&scoped=true&lang=pug&"
import script from "./TeamMatchCard.vue?vue&type=script&lang=js&"
export * from "./TeamMatchCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamMatchCard.vue?vue&type=style&index=0&id=6f6d654a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6d654a",
  null
  
)

export default component.exports